module.exports = __webpack_public_path__ + "img/icons-remove.a2317182.svg";